/* eslint-disable max-len */
import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';

interface Props {
  isActive?: boolean;
}

const ProjectName = styled.div<Props>`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px;
  gap: 11px;
  border-radius: 8px;
  .project-title {
    span {
      border-radius: 4px;
      ${Typography.body_sm_semibold}
    }
  }
  :hover {
    background-color: var(--neutral-secondary);
  }
  ${mobile_xl(css`
    max-width: -webkit-fill-available;
    padding: 11px 8px;
    gap: 8px;
    .project-title {
      span {
        border-radius: 6px;
      }
    }
  `)}
  ${(props: Props) =>
    props.isActive &&
    css`
      background-color: var(--background-muted);
      :hover {
        background-color: var(--background-muted);
      }
    `}
`;

const ProjectTitle = styled.p`
  color: var(--text-primary);
  ${Typography.body_md};
  margin: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
  ${mobile_xl(css`
    padding-bottom: 0;
    font-weight: 500;
  `)}
`;

export { ProjectName, ProjectTitle };
